/* eslint-disable jira/ff/unsafe-no-exposure */
/* eslint-disable jira/deprecations/ban-identifiers */
import type { Product, Edition } from '@atlassian/edition-awareness';
import { SOFTWARE, SERVICE_DESK } from '@atlassian/jira-shared-types/src/application-key.tsx';
import { getTrialDaysLeft } from '@atlassian/jira-growth-utils/src/common/index.tsx';
import { useProductEntitlementDetails } from '@atlassian/jira-tenant-context-controller/src/components/product-entitlement-details/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';

export const useIsEligibleForUpsellEa = ({
	product,
	edition,
	isSiteAdmin,
}: {
	product: Product | undefined;
	edition: Edition | undefined;
	isSiteAdmin: boolean;
}) => {
	const [expConfig] = UNSAFE_noExposureExp('edition_awareness_upsell_jira_ab');
	const productEntitlementDetails = useProductEntitlementDetails();

	// Enrollment logic
	const cohort = expConfig.get('cohort', 'not-enrolled');
	const enrolled = cohort !== 'not-enrolled';

	// Trial State logic
	let productKey;
	switch (product) {
		case 'jira':
			productKey = SOFTWARE;
			break;
		case 'jira-service-management':
			productKey = SERVICE_DESK;
			break;
		default:
	}

	const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
	const trialEndTime = entitlementDetails?.trialEndTime;
	const trialDaysLeft = getTrialDaysLeft(trialEndTime);
	const isInTrial = !entitlementDetails ? undefined : !!trialDaysLeft && trialDaysLeft > 0;

	const isEligibleForUpsellEa =
		edition === 'standard' &&
		enrolled &&
		isInTrial === false &&
		isSiteAdmin &&
		fg('edition_awareness_upsell_jira_ab_fg');

	return {
		isEligibleForUpsellEa,
		cohort,
	};
};
